<template>
  <MainHeader :miljo="miljo" />
  <NavigationBar />
  <router-view />
  <MainFooter />
</template>

<script setup lang="ts">
import MainHeader from "./components/header/MainHeader.vue";
import NavigationBar from "./components/header/NavigationBar.vue";
import MainFooter from "./components/footer/MainFooter.vue";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";

import { hamtaMiljo } from "./api";
useI18n({ useScope: "global" });

const miljo = ref<string>(""); 

onMounted(async () => {
	hamtaMiljo()
	.then( data => {
		miljo.value = data as string;
	    if (miljo.value !== "" && miljo.value !== "prod") {
	      document.title =  `[${miljo.value}] ${document.title}`;
	    }
	}).catch((error: string) => {
    console.log(`Hämtning av aktuell miljö misslyckades: ${error}`);
  });
});

</script>

<style lang="scss">
#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
}
</style>
